<script>
import { useUserStore } from '../../store/userStore.js';
import ChevronRightIcon from '@/assets/icons/ChevronRightIcon.vue';
import LogoutIcon from '@/assets/icons/LogoutIcon.vue';
import MoonIcon from '@/assets/icons/MoonIcon.vue';
import SunIcon from '@/assets/icons/SunIcon.vue';

export default {
  components: {
    ChevronRightIcon,
    LogoutIcon,
    SunIcon,
    MoonIcon,
  },
  setup() {
    const userStore = useUserStore();
    return { userStore };
  },
  data() {
    return {
      checked: false,
    };
  },
  watch: {
    $route(to, from) {
      if (to.name !== from.name) {
        this.menuClose();
      }
    },
  },
  methods: {
    changeLocale(langue) {
      this.$i18n.locale = langue;
    },
    menuOpen(e) {
      this.checked = e.target.checked;
    },
    menuClose() {
      this.checked = false;
      if (this.$refs.active) {
        this.$refs.active.checked = false;
      }
    },
    changeLanguage() {
      const newLocale = this.$i18n.locale === 'fr' ? 'en' : 'fr';
      this.userStore.setLanguage(newLocale);
    },
    loadView(route) {
      this.checked = false;
      this.$refs.active.checked = false;
      setTimeout(() => {
        this.$router.push(route);
      }, 200);
    },
    logout() {
      this.userStore.keycloak.logout();
      this.$router.push('/signin');
    },
  },
};
</script>

<template>
  <div class="main-menu">
    <div class="menu">
      <input id="active" ref="active" type="checkbox" @change="menuOpen" />
      <div class="wrapper" @click="menuClose">
        <div class="wrapper-content">
          <div class="wrapper-links">
            <router-link class="mobile-nav-link router-style" to="/argos">
              <div>{{ $t('main-menu.reco') }}</div>
              <ChevronRightIcon />
            </router-link>
            <router-link class="mobile-nav-link router-style" to="/ulis">
              <div>{{ $t('main-menu.recup') }}</div>
              <ChevronRightIcon />
            </router-link>
            <!--  <router-link class="mobile-nav-link router-style" to="/alcinos">
              <div to="/alcinos">
                {{ $t('main-menu.event') }}
              </div>
              <ChevronRightIcon />
            </router-link>  -->
          </div>
          <div class="wrapper-options">
            <div class="wrapper-option">
              <div class="mobile-option-link" @click="changeTheme">
                <div>{{ $t('main-menu.theme') }}</div>
                <div>
                  <SunIcon v-if="!userStore.isTheme" class="margin-icon icon-invert" />
                  <MoonIcon v-if="userStore.isTheme" class="margin-icon icon-invert" />
                </div>
              </div>
            </div>
            <div class="wrapper-option">
              <div class="mobile-option-link" @click="logout">
                <div>{{ $t('main-menu.signout') }}</div>
                <LogoutIcon class="margin-icon icon-invert" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.margin-icon {
  margin-left: 10px;
  width: 20px;
  height: 20px;
}

.router-style {
  text-decoration: none;
  color: var(--text);
}

.mobile-nav-link {
  display: flex;
  width: 80%;
  justify-content: space-between;
  text-transform: uppercase;
  font-size: 1rem;
  transition: color 0.2s ease;
  margin-bottom: 2rem;
}

@media (hover: hover) {
  .mobile-nav-link:hover {
    color: var(--text);
  }
}

.mobile-nav-link .router-link-active {
  color: var(--button-hover);
}

.main-menu {
  position: fixed;
  height: 60px;
  width: 50vw;
  margin-left: 50vw;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.menu {
  width: 55px;
}

.wrapper {
  position: fixed;
  display: flex;
  flex-direction: column;
  top: 0;
  left: 100%;
  height: 100%;
  width: 100%;
  background: var(--bg-secondary);
  transition: all 0.4s ease-in-out;
  overflow: hidden;
  z-index: 3;
}

.wrapper-content {
  width: 100%;
  height: 50%;
  padding: 150px 10px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.wrapper-links {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-left: 20px;
}

.wrapper-options {
  width: calc(100% - 20px);
  display: flex;
  flex-direction: column;
}

.wrapper-option {
  display: flex;
  flex-direction: row;
}

.mobile-option-link {
  display: flex;
  width: fit-content;
  justify-content: space-between;
  align-items: center;
  text-transform: uppercase;
  font-size: 1rem;
  transition: color 0.2s ease;
  margin-bottom: 2rem;
}

.menu-icon {
  height: 34px;
  width: 30px;
  color: var(--button-hover);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 15px;
  transition: all 0.2s ease-in-out;
}

.menu-btn {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
  right: 0;
  top: 0;
  height: 60px;
  width: 60px;
  cursor: pointer;
}

@media (hover: hover) {
  .menu-icon:hover {
    cursor: pointer;
    color: var(--text);
    transform: scale(1.1);
  }
}

input[type='checkbox'] {
  display: none;
}

#active:checked ~ .wrapper {
  left: 0;
}

.box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.btn {
  width: 30px;
  cursor: pointer;
}

.no-deco {
  text-decoration: none;
}

span {
  display: block;
  width: 100%;
  height: 2px;
  background: var(--bg-tertiary);
  transition: all 0.3s;
  position: relative;
}

.link-mobile {
  color: var(--text);
  padding: 5px 10px;
  text-align: left;
}

.link-box {
  width: calc(100% - 20px);
  padding: 5px 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  text-align: center;
  border: 1px solid var(--border);
  display: flex;
  align-items: center;
  transition: transform 0.2s ease;
}

@media (hover: hover) {
  .link-box:hover {
    transform: scale(1.05);
  }
}

.active-link {
  background-color: var(--bg-tertiary);
}

.active-link .link-mobile {
  color: var(--text);
}

.icon {
  width: 20px;
  height: 20px;
  color: var(--text-secondary);
}

.active-link .icon {
  color: var(--info);
}

span + span {
  margin-top: 7px;
}

.active span:nth-child(1) {
  animation: ease 0.7s top forwards;
}

.not-active span:nth-child(1) {
  animation: ease 0.7s top-2 forwards;
}

.active span:nth-child(2) {
  animation: ease 0.7s scaled forwards;
}

.not-active span:nth-child(2) {
  animation: ease 0.7s scaled-2 forwards;
}

.active span:nth-child(3) {
  animation: ease 0.7s bottom forwards;
}

.not-active span:nth-child(3) {
  animation: ease 0.7s bottom-2 forwards;
}

@keyframes top {
  0% {
    top: 0;
    transform: rotate(0);
  }

  50% {
    top: 9px;
    transform: rotate(0);
  }

  100% {
    top: 9px;
    transform: rotate(45deg);
  }
}

@keyframes top-2 {
  0% {
    top: 9px;
    transform: rotate(45deg);
  }

  50% {
    top: 9px;
    transform: rotate(0deg);
  }

  100% {
    top: 0;
    transform: rotate(0deg);
  }
}

@keyframes bottom {
  0% {
    bottom: 0;
    transform: rotate(0);
  }

  50% {
    bottom: 9px;
    transform: rotate(0);
  }

  100% {
    bottom: 9px;
    transform: rotate(135deg);
  }
}

@keyframes bottom-2 {
  0% {
    bottom: 9px;
    transform: rotate(135deg);
  }

  50% {
    bottom: 9px;
    transform: rotate(0);
  }

  100% {
    bottom: 0;
    transform: rotate(0);
  }
}

@keyframes scaled {
  50% {
    transform: scale(0);
  }

  100% {
    transform: scale(0);
  }
}

@keyframes scaled-2 {
  0% {
    transform: scale(0);
  }

  50% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}
</style>
